import React from 'react';

// One screenshot in one of the approved presentations. The wrapper owns the radius; the screenshot itself is never
// cropped (no object-fit, height:auto), so titles and statuses cannot be cut off.
//   mat   - app-coloured mat (desktop screens)      white  - white mat (service screens)
//   phone - dark phone shell                         pan    - horizontally scrollable mat (mobile calendar)
const ProductShot = ({ image, variant = 'mat', className = '', panWidth, panLabel }) => {
  const img = (style) => (
    <img src={image.src} width={image.width} height={image.height} loading="lazy" alt={image.alt} style={style} />
  );

  if (variant === 'phone') return <div className={`zl-phone ${className}`}>{img()}</div>;
  if (variant === 'pan') {
    return (
      <div className="zl-pan" tabIndex={0} role="region" aria-label={panLabel}>
        <div className="zl-mat">{img({ '--w': `${panWidth}px` })}</div>
      </div>
    );
  }
  return <div className={`zl-mat ${variant === 'white' ? 'zl-mat-white' : ''} ${className}`}>{img()}</div>;
};

export default ProductShot;
